import React from 'react'
import SideMenu from './SideMenu'
import GovernanceHero from '../governance/GovernanceHero'
import { stockexchange } from '../../js/StockExchangeAnnounce';

function StockExchangeAnnouncment() {
    return (
        <div>
            <GovernanceHero headingText={'Stock Exchange'} />

            <div className='mx-auto max-w-7xl py-8'>
                <div className='md:flex lg:flex xl:flex 2xl:flex'>
                    <div className='lg:px-6 md:px-6 xl:px-6 px-2 md:pb-6 lg:pb-6 xl:pb-6 pb-4 max-w-4xl w-full'>
                        <h2 class="my-4 text-2xl text-gray-700 font-bold">Stock Exchange Annoucements</h2>


                        <div class="relative overflow-x-auto  p-2">

                            <table class=" text-sm text-left rtl:text-right text-gray-500">

                                {stockexchange.map(exchanges => (
                                    <tbody>
                                        <tr class="border-b border-gray-200 ">
                                            <tr class="px-6 py-4">
                                                {exchanges.Heading1}
                                            </tr>
                                            <td class="px-6 py-4">
                                                {exchanges.Heading2}
                                            </td>
                                            <td class="px-6 py-4 max-w-lg">
                                                {exchanges.Text}
                                            </td>

                                            <a href={exchanges.PDF} target="_blank" rel="noopener noreferrer">
                                                <td class="px-6 py-4 text-[#2baf2b]">
                                                    Download
                                                </td>
                                            </a>
                                        </tr>

                                    </tbody>
                                ))}
                            </table>
                        </div>


                    </div>

                    <div className='md:px-0 lg:px-0 xl:px-0 2xl:px-0 px-3.5'>
                        <SideMenu />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StockExchangeAnnouncment